import { messages as messages$1 } from "../locales/en/messages.js";
import { messages as messages$2 } from "../locales/es/messages.js";
import { messages as messages$3 } from "../locales/pt-br/messages.js";
import { setupI18n } from "@lingui/core";
var i18n = setupI18n({
	locale: "pt-br",
	locales: [
		"pt-br",
		"es",
		"en"
	],
	messages: {
		en: messages$1,
		"pt-br": messages$3,
		es: messages$2
	}
});
//#endregion
export { i18n };
